import IComic from '#/types/comics';
import { ComicsActionType, TComicsActions } from '../actions/comics';

interface IState {
  comics: IComic[];
  search: string;
  selectedFormat: string;
  page: number;
  totalPages: number;
  loading: boolean;
}

const initialState: IState = {
  comics: [],
  search: '',
  selectedFormat: '',
  page: 1,
  totalPages: 0,
  loading: false,
};

const comicsReducer = (
  state = initialState,
  action: TComicsActions
): IState => {
  switch (action.type) {
    case ComicsActionType.COMICS_SET_COMICS:
      return { ...state, comics: action.payload };

    case ComicsActionType.COMICS_SET_SEARCH:
      return { ...state, search: action.payload };

    case ComicsActionType.COMICS_SET_SELECTED_FORMAT:
      return { ...state, selectedFormat: action.payload };

    case ComicsActionType.COMICS_SET_PAGE:
      return { ...state, page: action.payload };

    case ComicsActionType.COMICS_SET_TOTAL_PAGES:
      return { ...state, totalPages: action.payload };

    case ComicsActionType.COMICS_START_LOADING:
      return { ...state, loading: true };

    case ComicsActionType.COMICS_STOP_LOADING:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default comicsReducer;
